import { create } from 'zustand'

// amusnet react ui promo component related states
export interface PromoState {
    closePromoSignal: number
    closePromo: () => void
}

export const usePromoStore = create<PromoState>((set) => ({
    closePromoSignal: 0,
    closePromo: () => {
        set((state) => ({ closePromoSignal: state.closePromoSignal + 1 }))
    },
}))
